/**
 * This fixes the issue of when a Video molecule is added in the Hero (media-small) and when clicking the video poster
 * it doesn't open the video modal.
 */
export default function enableVideo() {
  Array.from( document.querySelectorAll( '.js-hero-media-small' ) ).forEach(
    heroContainer => main( heroContainer )
  )

  /**
   * Get HTML nodes and call functions.
   *
   * @param {object} heroContainer The Hero main node container.
   */
  function main( heroContainer ) {
    const videoPoster = heroContainer
      .querySelector( '.js-video-poster' )

    const heroOverlay = heroContainer.querySelector( '.js-atom-overlay' )
    if ( heroOverlay ) {
      heroOverlay.addEventListener( 'click', event => triggerVideo( event ) )
    }

    /**
     * Simulates a click in the Video Poster to open the video modal.
     *
     * @param {object} event The click event.
     */
    function triggerVideo( event ) {
      event.stopPropagation()
      videoPoster.click()
    }
  }
}
